import React from 'react';
import { motion } from 'framer-motion';
import PageWrapper from '../components/layout/PageWrapper';
import HomeHero from '../components/home/HomeHero';
import IntegrationsTicker from '../components/home/IntegrationsTicker';
import HowItWorks from '../components/home/HowItWorks';
import StatsSection from '../components/home/StatsSection';
import Manifesto from '../components/home/Manifesto';
import Testimonials from '../components/home/Testimonials';
import CTASection from '../components/home/CTASection';

// Motion wrapper for consistent reveal effects
const SectionWrapper = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 60, scale: 0.98 }}
    whileInView={{ opacity: 1, y: 0, scale: 1 }}
    viewport={{ once: true, margin: "-100px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }} // Custom easing for premium feel
    className={className}
  >
    {children}
  </motion.div>
);

export default function HomePage() {
  return (
    <PageWrapper>
      {/* Hero loads immediately, but we wrap it for consistency in structure */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <HomeHero />
      </motion.div>

      <SectionWrapper delay={0.1}>
        <IntegrationsTicker />
      </SectionWrapper>

      <SectionWrapper delay={0.2}>
        <HowItWorks />
      </SectionWrapper>

      <SectionWrapper>
        <StatsSection />
      </SectionWrapper>

      <SectionWrapper>
        <Manifesto />
      </SectionWrapper>

      <SectionWrapper>
        <Testimonials />
      </SectionWrapper>

      <SectionWrapper>
        <CTASection />
      </SectionWrapper>
    </PageWrapper>
  );
}